var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Data } from './data';
import { Reward } from './reward';
import { OrderItem } from './order-item';
var Offer = /** @class */ (function (_super) {
    __extends(Offer, _super);
    function Offer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.class = "Offer";
        _this.orderitems = [];
        return _this;
    }
    Offer.prototype.toProperty = function (name, value) {
        if (name == "reward") {
            return Data.toData(Reward, value);
        }
        return value;
    };
    Offer.toOffersData = function (offers) {
        var result = [];
        for (var _i = 0, offers_1 = offers; _i < offers_1.length; _i++) {
            var offer = offers_1[_i];
            var tmp = Offer.toOfferData(offer);
            result.push(tmp);
        }
        return result;
    };
    Offer.toOfferData = function (offer) {
        var json = {};
        json["id"] = offer.id;
        json["name"] = offer.name;
        json["hint"] = offer.hint;
        json["publihed"] = offer.publihed;
        json["backendId"] = offer.backendId;
        json["orderitems"] = OrderItem.toOrderItemsData(offer.orderitems);
        json["reward"] = Reward.toRewardData(offer.reward);
        json["campaignId"] = offer.campaignId;
        json["rewardId"] = offer.rewardId;
        return json;
    };
    return Offer;
}(Data));
export { Offer };
//# sourceMappingURL=offer.js.map